/**
 * ExplicacaoCard — o "?" no título de um card de painel.
 *
 * O comportamento do "?" (abre no clique, fecha no Esc/×/fora, balão em
 * portal) mora no BalaoAjuda; aqui fica só o conteúdo de um card de painel.
 *
 * `explicacao` = { oQueE, comoContado: string[], exemplo, atencao? } — o
 * conteúdo mora num arquivo de explicações do painel, indexado pelo id do
 * card, separado do desenho do card.
 */
import React from "react";

import BalaoAjuda, { posicionarBalao } from "../BalaoAjuda";

export { posicionarBalao };

function ExplicacaoCard({ titulo, explicacao }) {
  if (!explicacao) return null;

  return (
    <BalaoAjuda
      titulo={titulo}
      rotuloGatilho={`O que é: ${titulo}`}
      rotuloBalao={`Como ler: ${titulo}`}
      dica="Como este número é contado"
    >
      <section>
        <h4>O que é</h4>
        <p>{explicacao.oQueE}</p>
      </section>
      <section>
        <h4>Como é contado</h4>
        <ul>
          {explicacao.comoContado.map((passo) => (
            <li key={passo}>{passo}</li>
          ))}
        </ul>
      </section>
      <section>
        <h4>Exemplo</h4>
        <p>{explicacao.exemplo}</p>
      </section>
      {explicacao.atencao ? (
        <section className="explicacao-card__atencao">
          <h4>Atenção</h4>
          <p>{explicacao.atencao}</p>
        </section>
      ) : null}
    </BalaoAjuda>
  );
}

export default ExplicacaoCard;
